import { render, staticRenderFns } from "./RequiredModification.vue?vue&type=template&id=c82b8d4e&scoped=true"
import script from "./RequiredModification.vue?vue&type=script&lang=js"
export * from "./RequiredModification.vue?vue&type=script&lang=js"
import style0 from "./RequiredModification.vue?vue&type=style&index=0&id=c82b8d4e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82b8d4e",
  null
  
)

export default component.exports